import type { SVGProps } from 'react';
const SvgPermScanWifi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#perm_scan_wifi_svg__a)">
      <path
        fill="currentColor"
        d="M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3Zm1 13h-2v-6h2v6Zm-2-8V6h2v2h-2Z"
      />
    </g>
    <defs>
      <clipPath id="perm_scan_wifi_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPermScanWifi;
